<div class="pending-balances-dashboard">
  <!-- Toast Messages -->
  <p-toast></p-toast>
  
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner></p-progressSpinner>
    <p>Cargando saldos pendientes...</p>
  </div>

  <!-- Dashboard Content -->
  <div *ngIf="!loading">
    <!-- Header with Metrics Cards -->
    <div class="metrics-header mb-4">
      <div class="col-12 cards-numbers-container" style="padding: 0px;">
        
        <div class="dashboard-card">
          <div class="card-content">
            <div class="icon-container-red">
              <i class="fa-solid fa-exclamation-triangle card-icon-red"></i>
            </div>
            <h2>{{metrics.totalClients}}</h2>
            <p>Clientes Morosos</p>
          </div>
        </div>

        <div class="dashboard-card">
          <div class="card-content">
            <div class="icon-container-orange">
              <i class="fa-solid fa-dollar-sign card-icon-orange"></i>
            </div>
            <h2>{{metrics.totalDebt | currency:'MXN':'symbol':'1.2-2'}}</h2>
            <p>Deuda Total</p>
          </div>
        </div>

        <div class="dashboard-card">
          <div class="card-content">
            <div class="icon-container-blue">
              <i class="fa-solid fa-clock card-icon-blue"></i>
            </div>
            <h2>{{metrics.averageOverdueDays}}</h2>
            <p>Días Promedio</p>
          </div>
        </div>

        <div class="dashboard-card">
          <div class="card-content">
            <div class="icon-container-red">
              <i class="fa-solid fa-times-circle card-icon-red"></i>
            </div>
            <h2>{{metrics.criticalClients}}</h2>
            <p>Críticos (+60 días)</p>
          </div>
        </div>

      </div>
    </div>

    <!-- Charts Section -->
    <div class="charts-section mb-4">
      <div class="grid">
        <!-- Monthly Totals Chart -->
        <div class="col-12 lg:col-6">
          <div class="card-style">
            <div>
              <h2 style="margin-bottom: 12px;">Saldos Vencidos por Mes</h2>
              
              <div class="chart-container">
                <p-chart 
                  height="350px"
                  type="bar" 
                  [data]="monthlyTotalsChart" 
                  [options]="barChartOptions"
                  *ngIf="monthlyTotalsChart">
                </p-chart>
              </div>
            </div>
          </div>
        </div>

        <!-- Overdue Analysis Chart -->
        <div class="col-12 lg:col-6">
          <div class="card-style">
            <div>
              <h2 style="margin-bottom: 12px;">Análisis: Días de Atraso vs Deuda Total</h2>
              
              <div class="chart-container">
                <p-chart 
                  height="350px"
                  type="bar" 
                  [data]="overdueAnalysisChart" 
                  [options]="overdueRangeChartOptions"
                  *ngIf="overdueAnalysisChart">
                </p-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Monthly Debt Matrix Section -->
  <div class="col-12 mb-3">
    <div class="matrix-section">
      <div class="matrix-header">
        <h3 class="section-title">
          <i class="fas fa-th mr-2"></i>
          Matriz de Deuda Mensual por Cliente
        </h3>
        <p class="section-subtitle">
          Visualización de adeudos mensuales por cliente (últimos 12 meses)
        </p>
        <div class="matrix-controls">
          <p-selectButton
            [options]="groupingOptions"
            [(ngModel)]="groupBy"
            (onChange)="onGroupingChange()"
            optionLabel="label"
            optionValue="value"
            class="grouping-toggle"
            *ngIf="showMonthlyMatrix && monthlyDebtMatrix.length > 0">
            <ng-template let-item pTemplate>
              <i [class]="item.icon" class="mr-1"></i>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-selectButton>

          <p-button
            icon="pi pi-file-excel"
            [text]="true"
            [rounded]="true"
            severity="success"
            (onClick)="exportMatrixToExcel()"
            pTooltip="Exportar Matriz a Excel"
            tooltipPosition="top"
            class="action-btn"
            *ngIf="showMonthlyMatrix && monthlyDebtMatrix.length > 0">
          </p-button>

        </div>
      </div>

      <div class="matrix-container" *ngIf="showMonthlyMatrix">
        <div class="matrix-table-wrapper">
          <table class="monthly-debt-matrix" *ngIf="monthlyDebtMatrix.length > 0">
            <thead>
              <tr>
                <th class="client-column sticky-left">Cliente</th>
                <th class="folio-column sticky-left-2">
                  {{ groupBy === 'client' ? 'Arrend.' : 'Folio' }}
                </th>
                <th class="month-column" *ngFor="let month of matrixMonths">
                  {{month.label}}
                </th>
                <th class="total-column sticky-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let client of monthlyDebtMatrix; trackBy: trackByClientId" 
                  class="matrix-row">
                <td class="client-cell sticky-left">
                  <div class="client-info">
                    <span class="client-name" [title]="client.clientName">
                      {{truncateClientName(client.clientName, 42)}}
                    </span>
                  </div>
                </td>
                <td class="folio-cell sticky-left-2">
                  <p-tag
                    *ngIf="groupBy === 'lease'"
                    severity="info"
                    [value]="client.folio"
                    class="folio-tag clickeable"
                    (click)="navigateToLeaseFromMatrix(client)">
                  </p-tag>
                  <p-tag
                    *ngIf="groupBy === 'client'"
                    severity="secondary"
                    [value]="client.leaseCount + (client.leaseCount === 1 ? ' arrend.' : ' arrend.')"
                    [pTooltip]="(client.leaseFolios || []).join(', ')"
                    tooltipPosition="top"
                    class="folio-tag">
                  </p-tag>
                </td>
                <td class="amount-cell" *ngFor="let month of matrixMonths">
                  <ng-container *ngIf="client.monthlyDebts[month.key] as cell; else emptyCell">
                    <div class="split-bar-container"
                         *ngIf="cell.status !== 'no-period'; else emptyCell"
                         [ngClass]="'status-' + cell.status"
                         [pTooltip]="'Pagado: ' + fmt(cell.paid) + ' / Esperado: ' + fmt(cell.expected)"
                         tooltipPosition="top">
                      <div class="split-bar">
                        <div class="split-bar__paid" [style.width.%]="getPaidPercent(cell)"></div>
                        <div class="split-bar__pending" [style.width.%]="100 - getPaidPercent(cell)"></div>
                      </div>
                      <span class="debt-amount" [ngClass]="cell.status === 'paid' ? 'text-green-600' : ''">
                        <ng-container *ngIf="cell.status === 'paid'">Pagado</ng-container>
                        <ng-container *ngIf="cell.status !== 'paid'">{{ cell.pending | currency:'MXN':'symbol':'1.2-2' }}</ng-container>
                      </span>
                    </div>
                  </ng-container>
                  <ng-template #emptyCell>
                    <div class="empty-cell">-</div>
                  </ng-template>
                </td>
                <td class="total-cell sticky-right">
                  <div class="total-debt" 
                       [ngClass]="getDebtSeverityClass(client.totalDebt)">
                    <strong>{{client.totalDebt | currency:'MXN':'symbol':'1.2-2'}}</strong>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <div *ngIf="monthlyDebtMatrix.length === 0" class="no-data-matrix">
            <i class="fas fa-chart-bar fa-3x text-muted mb-3"></i>
            <h4>No hay datos de matriz mensual disponibles</h4>
            <p>No se encontraron registros de deuda mensual para mostrar en la matriz.</p>
          </div>
        </div>

        <!-- Matrix Legend -->
        <div class="matrix-legend mt-3">
          <h5>Leyenda:</h5>
          <div class="legend-items">
            <div class="legend-item">
              <div class="legend-bar legend-bar--paid"></div>
              <span>Pagado completo</span>
            </div>
            <div class="legend-item">
              <div class="legend-bar legend-bar--partial">
                <div class="legend-bar__paid"></div>
                <div class="legend-bar__pending"></div>
              </div>
              <span>Pago parcial</span>
            </div>
            <div class="legend-item">
              <div class="legend-bar legend-bar--unpaid"></div>
              <span>Sin pago</span>
            </div>
            <div class="legend-item">
              <div class="legend-bar legend-bar--empty"></div>
              <span>Sin periodo / sin deuda</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <!-- Monthly Detail Modal -->
  <p-dialog 
    header="Desglose Mensual" 
    [(visible)]="displayMonthlyModal" 
    [modal]="true" 
    [style]="{width: '80vw', maxWidth: '900px'}"
    [closable]="true">
    
    <div *ngIf="selectedClient">
      <div class="client-modal-header mb-4">
        <h4 class="mb-2">{{selectedClient.clientName}}</h4>
        <div class="flex gap-3">
          <p-tag 
            severity="info" 
            [value]="'Folio: ' + selectedClient.folio">
          </p-tag>
          <p-tag 
            severity="warning" 
            [value]="'Deuda Total: ' + (selectedClient.totalAccumulatedDebt | currency:'MXN':'symbol':'1.2-2')">
          </p-tag>
          <p-tag 
            [severity]="getOverdueSeverity(selectedClient.totalOverdueDays)"
            [value]="selectedClient.totalOverdueDays + ' días de atraso'">
          </p-tag>
        </div>
      </div>

      <!-- Client Monthly Chart -->
      <div class="chart-container mb-4" style="height: 300px;">
        <p-chart 
          type="bar" 
          [data]="clientMonthlyChart" 
          [options]="lineChartOptions"
          *ngIf="clientMonthlyChart">
        </p-chart>
      </div>

      <!-- Monthly Breakdown Table -->
      <p-table [value]="selectedClient.pendingBalancesByMonth" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>Mes</th>
            <th>Monto Adeudado</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-monthData>
          <tr>
            <td>{{formatMonthLabel(monthData.month)}}</td>
            <td>{{monthData.amount | currency:'MXN':'symbol':'1.2-2'}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-dialog>

  <!-- Detailed Table -->
    <div class="table-section">
      <div class="card-style">
        <div class="table-header-bar">
          <h3 class="table-title">Detalle de Saldos Pendientes por Cliente</h3>
          
          <div class="search-input">
            <i class="pi pi-search"></i>
            <input 
              type="text" 
              pInputText 
              [(ngModel)]="globalFilter"
              (input)="onGlobalFilterChange()"
              placeholder="Buscar por cliente o folio...">
          </div>
          
          <p-dropdown 
            [(ngModel)]="selectedOverdueRange" 
            [options]="overdueRanges"
            optionLabel="label"
            placeholder="Todos"
            (onChange)="onOverdueRangeChange()"
            class="days-filter">
          </p-dropdown>
          
          <p-button 
            icon="pi pi-file-excel" 
            [text]="true"
            [rounded]="true"
            severity="success"
            (onClick)="exportToExcel()"
            pTooltip="Exportar a Excel"
            tooltipPosition="top"
            class="action-btn">
          </p-button>
          
          <p-button 
            icon="pi pi-refresh" 
            [text]="true"
            [rounded]="true"
            severity="info"
            (onClick)="refresh()"
            pTooltip="Actualizar datos"
            tooltipPosition="top"
            class="action-btn">
          </p-button>
          
          <p-badge 
            [value]="filteredClientsData.length.toString()" 
            severity="info"
            class="count-badge">
          </p-badge>
        </div>
        
        <p-table 
          [value]="filteredClientsData" 
          [paginator]="true" 
          [rows]="10"
          [showCurrentPageReport]="true" 
          [rowsPerPageOptions]="[10,25,50]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
          responsiveLayout="scroll"
          styleClass="p-datatable-gridlines"
          [scrollable]="true"
          scrollHeight="600px">
          
          <ng-template pTemplate="body" let-client>
            <tr>
              <td>
                <div class="folio-cell">
                  <span
                    *ngIf="groupBy === 'lease'"
                    class="folio-badge clickeable"
                    (click)="navigateToLease(client)"
                  >
                    {{client.folio}}
                  </span>
                  <p-tag
                    *ngIf="groupBy === 'client'"
                    severity="secondary"
                    [value]="client.leaseCount + ' arrend.'"
                    [pTooltip]="(client.leaseFolios || []).join(', ')"
                    tooltipPosition="top">
                  </p-tag>
                </div>
              </td>
              <td>
                <div class="client-info">
                  <div class="client-name font-medium">{{client.clientName}}</div>
                  <small class="text-500" *ngIf="groupBy === 'lease'">{{client.contract}}</small>
                  <small class="text-500" *ngIf="groupBy === 'client'">{{client.leaseCount}} arrendamiento{{client.leaseCount === 1 ? '' : 's'}}</small>
                </div>
              </td>
              <td>
                <div class="debt-progress"
                     [pTooltip]="'Pagado: ' + (client.totalPaid | currency:'MXN':'symbol':'1.2-2') + ' / Esperado: ' + (client.totalExpected | currency:'MXN':'symbol':'1.2-2')"
                     tooltipPosition="top">
                  <div class="debt-progress__amounts">
                    <span class="debt-amount" [ngClass]="getDebtSeverityClass(client.totalAccumulatedDebt)">
                      {{client.totalAccumulatedDebt | currency:'MXN':'symbol':'1.2-2'}}
                    </span>
                    <small class="text-500">
                      / {{client.totalExpected | currency:'MXN':'symbol':'1.2-2'}}
                    </small>
                  </div>
                  <div class="split-bar mt-1" *ngIf="client.totalExpected > 0">
                    <div class="split-bar__paid" [style.width.%]="getRowPaidPercent(client)"></div>
                    <div class="split-bar__pending" [style.width.%]="100 - getRowPaidPercent(client)"></div>
                  </div>
                </div>
              </td>
              <td>
                <p-tag
                  [value]="client.totalOverdueDays + ' días'"
                  [severity]="getOverdueSeverity(client.totalOverdueDays)">
                </p-tag>
              </td>
              <td>
                <span class="month-count">{{client.pendingBalancesByMonth.length}} meses</span>
              </td>
              <td>
                <div class="action-buttons">
                  <p-button
                    icon="pi pi-eye"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    severity="info"
                    (onClick)="showMonthlyDetail(client)"
                    pTooltip="Ver desglose mensual"
                    tooltipPosition="top">
                  </p-button>
                  <p-button
                    icon="pi pi-envelope"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    severity="success"
                    (onClick)="contactClient(client)"
                    pTooltip="Enviar email"
                    tooltipPosition="top">
                  </p-button>
                  <p-button
                    icon="pi pi-file-pdf"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    severity="warning"
                    (onClick)="generateStatement(client)"
                    pTooltip="Estado de cuenta"
                    tooltipPosition="top">
                  </p-button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 210px;">{{ groupBy === 'client' ? 'Arrend.' : 'Folio' }}</th>
              <th>Cliente</th>
              <th style="width: 220px;" class="sortable-header" (click)="onSort('totalAccumulatedDebt')">
                <div style="display: flex; align-items: center;">
                  <span>Deuda / Esperado </span>
                  <i class="sort-icon" [ngClass]="getSortIconClass('totalAccumulatedDebt')"></i>
                </div>
              </th>
              <th style="width: 140px;" class="sortable-header" (click)="onSort('totalOverdueDays')">
                <div style="display: flex; align-items: center;">
                  <span>Días Atraso </span>
                  <i class="sort-icon" [ngClass]="getSortIconClass('totalOverdueDays')"></i>
                </div>
              </th>
              <th style="width: 100px;" class="sortable-header" (click)="onSort('periods')">
                <div style="display: flex; align-items: center;">
                  <span>Períodos </span>
                  <i class="sort-icon" [ngClass]="getSortIconClass('periods')"></i>
                </div>
              </th>
              <th style="width: 150px;">Acciones</th>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

</div>